import { talkativeConfig } from "./talkative-config.js";
import { useEffect } from "react";

//#region src/TalkativeInitializer.tsx
window.talkativeCustomConfig = talkativeConfig;
let hasLoadedScript = false;
const LOADER_URL = "https://us.engage.app/api/ecs/v1/loader/93c017d2-a496-4b71-9ef4-25789b0c867c.js";
const getSelectedVersionParam = () => new URLSearchParams(window.location.search).get("ecsSelectedVersion") ?? "";
const buildScriptUrl = (isTollFree) => {
	const appUrl = new URL(LOADER_URL);
	const basePath = window.location.origin + window.location.pathname;
	const path = isTollFree ? `${basePath}/?number=tollfree` : basePath;
	const selectedVersion = getSelectedVersionParam();
	appUrl.searchParams.append("path", path);
	appUrl.searchParams.append("selectedVersion", selectedVersion);
	return appUrl.href;
};
const TalkativeInitializer = ({ tollFreeStates, patientState } = {}) => {
	useEffect(() => {
		const tlkStyle = document.createElement("style");
		document.head.appendChild(tlkStyle);
		tlkStyle.appendChild(document.createTextNode("#talkative-engage {position: absolute; z-index: -1;}"));
	}, []);
	useEffect(() => {
		if (hasLoadedScript) return;
		hasLoadedScript = true;
		import(buildScriptUrl(Boolean(patientState && tollFreeStates?.includes(patientState)))).catch((error) => {
			window.telemetry?.logUnknownError({ source: "TalkativeInitializer" }, error);
		});
	}, [tollFreeStates, patientState]);
	return null;
};

//#endregion
export { TalkativeInitializer };